<template>

  <div>
  <!--车辆品牌-->
<!--  <el-tab-pane label="车辆品牌" name="brandList">-->
<!--    <el-row v-show="showFilters">-->
      <el-form :model="brandSearchForm" ref="brandSearchForm" size="mini" :inline="true" :rules="searchFormRules">
        <el-col :span="3">
          <el-form-item prop="brand">
            <el-input placeholder="品牌" v-model="brandSearchForm.brand" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1.5">
          <el-form-item>
            <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="1.5">
          <el-form-item>
            <el-button size="mini" type="primary" @click="search"
                       :loading="getBrandLoading">查询
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="1.5">
          <el-form-item>
            <el-button size="mini" type="primary" @click="carBrandAdd" icon="el-icon-plus" class="el-btn"
                       v-if="checkPermission(['bee:res:brand:saveOrUpdateBrand'])">
              新增品牌
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>
<!--    </el-row>-->
    <!--列表数据-->
    <el-table :data="brandTableData" stripe style="width: 100%" ref="carBrandTable" border
              @selection-change="handleSelectionChange" v-loading="carBrandLoading">
      <af-table-column prop="type" label="分类"></af-table-column>
      <af-table-column prop="brand" label="品牌"></af-table-column>
      <af-table-column prop="createTime" label="创建时间" :formatter="dateFormatter"></af-table-column>
      <af-table-column label="操作" width="240px">
        <template slot-scope="scope">
          <el-button size="mini" plain @click="brandEdit(scope.$index, scope.row)"
                     v-if="checkPermission(['bee:res:brand:updateBrand'])">编辑
          </el-button>
          <el-button size="mini" plain type="danger" @click="brandDelete(scope.$index, scope.row)"
                     v-if=" checkPermission(['bee:res:brand:deleteBrand'])">删除
          </el-button>
        </template>
      </af-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="changeBrandPage"></Pagination>
<!--  </el-tab-pane>-->

    <!-- 添加界面 -->
    <AddPage
      :form-visible="addBrandFormVisible"
      @closeDialog="closeDialog"
      @afterAdd="afterAdd"
    ></AddPage>
    <EditPage
      :form-visible="editBrandFormVisible"
      :selectRowData="selectRowData"
      @closeDialog="closeDialog"
      @afterEdit="afterEdit"
    ></EditPage>
  </div>
</template>

<script>
    import Pagination from "../../../../../components/Pagination";
    import carApi from "../../../api/carApi";
    import AddPage from '@/module/resourceCenter/page/car/brand/add.vue';
    import EditPage from '@/module/resourceCenter/page/car/brand/edit.vue';
    // import checkPermission from "src/common/permission";
    import {validateInput} from '../../../../../common/validator';

    export default {
        name: "list",
        data() {
            return {
                searchFormRules: {
                    brand: [
                        {validator: function (rule, value, callback) {
                                validateInput(rule, value, callback,0,10,true,true,false,true,true,false,false)
                            }, trigger: 'blur'}],
                },
                views: {},
                enumData: [{
                    carTypeData: ''
                }],
                inputVisible: false,
                inputValue: '',
                // restaurants: [],
                tableData: [{}],
                modelTableData: [{}],
                brandTableData: [{}],
                carSearchForm: {},
                modelSearchForm: {},
                brandSearchForm: {},
                listForSelectQuery: {},
                operatorForSelect: '',
                listForSelect: {},
                getCarsLoading: false,
                getBrandLoading: false,
                getModelsLoading: false,
                addForm: {},
                editForm: {},
                carsLoading: false,
                addModelForm: {},
                editModelForm: {},
                addBrandForm: {},
                editBrandForm: {},
                editTypeForm: {},
                addSubmitLoading: false,
                editSubmitLoading: false,
                carModelLoading: false,
                addModelSubmitLoading: false,
                editModelSubmitLoading: false,
                addBrandSubmitLoading: false,
                editBrandSubmitLoading: false,
                carBrandLoading: false,
                innerForm: {},
                searchTabsAddForm: {},
                addFormVisible: false,
                editFormVisible: false, // 外部对话框
                addModelFormVisible: false,
                editModelFormVisible: false,
                addBrandFormVisible: false,
                editBrandFormVisible: false,
                viewVisible: false, // 视图
                multipleSelection: [],
                activeName: 'modelList',
                innerFormName: 'coordinate',
                viewName: 'detailForm',
                showFilters: true,
                input: '',
                val_time: '', // 创建时间
                formLabelWidth: '150px',
                // 分页参数
                pageparm: {
                    t: {},
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                },
                activeNames: ['basicInformation', 'addressInformation'],
                activeName: 'modelList',
                // 选中列数据
                selectRowData: {}
            }
        },
        methods: {
            carTableClick(tab, event) {
                console.log(tab, event)
            },

            carBrandAdd() {
                this.$nextTick(() => {
                    this.addBrandFormVisible = true
                    this.addBrandForm = Object.assign({})
                })
                console.log(this.addBrandFormVisible)
            },
            brandEdit(index, row) {
                // this.addBrandFormVisible = true
                // this.addBrandForm = Object.assign({}, row)
                // this.addBrandForm.type = this.addBrandForm.type
                // this.addBrandForm.brand = this.addBrandForm.brand
                this.editBrandFormVisible = true
                if (row !== undefined) {
                    this.selectRowData =  Object.assign({}, row)
                    this.editBrandFormVisible = true;
                    console.log(this.selectRowData)
                }

            },
            brandDelete(index, row) {
                this.$confirm('确定要删除：' + row.brand + '吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.carBrandLoading = true
                        let param = {id: row.id}
                        carApi.deleteBrand(param).then((res) => {
                            if (res.code === 0) {
                                this.$message({
                                    message: res.message,
                                    type: '删除成功'
                                })
                                this.submitBrandSearchForm()
                            } else {
                                this.$message.error(res.message)
                            }
                            this.carBrandLoading = false
                        })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除！'
                        })
                    })
            },
            resetSearchForm() {
                this.brandSearchForm = {}
                this.submitBrandSearchForm()
            },

            submitBrandSearchForm() {
                this.$refs.brandSearchForm.validate((valid) => {
                    if (!valid) {
                        return;
                    }
                    this.getBrandLoading = true
                    this.carBrandLoading = true
                    this.pageparm.t = this.brandSearchForm
                    let param = Object.assign({}, this.pageparm)
                    carApi.getBrands(param).then((res) => {
                        if (res.code === 0) {
                            this.pageparm.total = res.data.total
                            this.brandTableData = res.data.records
                            // this.$message({
                            //     message: res.message,
                            //     type: 'success'
                            // })
                        } else {
                            this.$message.error(res.message)
                        }
                        this.getBrandLoading = false
                        this.carBrandLoading = false
                    })
                })

            },

            //查询
            search()
            {
                this.pageparm.currentPage = 1
                this.submitBrandSearchForm()

            },
            // 添加成功后操作
            afterAdd() {
                this.addBrandFormVisible = false
                this.submitBrandSearchForm()
            },
            // 编辑成功后操作
            afterEdit() {
                this.editBrandFormVisible = false
                this.submitBrandSearchForm()
            },
            // 关闭弹框
            closeDialog(type) {
                console.log('type:' + type)
                if (type === 'add' || type === 'update') {
                    this.addBrandFormVisible  = false
                    this.editBrandFormVisible  = false
                }
                //console.log(this.addBrandFormVisible)
            },
            // 日期格式化
            dateFormatter(row, column) {
                let datetime = row.createTime+'';
              return datetime.substring(0,10)
            },

            brandDelete(index, row) {
                this.$confirm('确定要删除：' + row.brand + '吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.carBrandLoading = true
                        let param = {id: row.id}
                        carApi.deleteBrand(param).then((res) => {
                            if (res.code === 0) {
                                this.$message({
                                    message: res.message,
                                    type: 'success'
                                })
                                // this.submitBrandSearchForm()
                            } else {
                                this.$message.error(res.message)
                            }
                            this.carBrandLoading = false
                        })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除！'
                        })
                    })
            },

            handleSelectionChange(val) {
                this.multipleSelection = val
            },


            changeBrandPage() {
                this.submitBrandSearchForm()
            },

            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
                }
            },
            handleSelect(item) {
                console.log(item)
            }
        },
        components: {
            Pagination,
            AddPage,
            EditPage
        },
        created: function () {

        },
        mounted: function () {
            this.submitBrandSearchForm()
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/car/brand/list.vue